<template>
  <div class="">
    <div class="" style="background: #eee">
        <div class="topnav">
            <div class="marginauto flex justify-between align-center" style="width: 82%;height: 80px;">
                <div class="text-white" style="font-size: 25px;font-weight: 600;">中云微迅创新平台</div>
                <div class="text-white pointer" @click="tohome" style="font-size: 18px;">首页</div>
            </div>
        </div>
      <div class="box">
        <el-image style="width: 100%;display:block;height: 410px" src="/static/assets/images/p4.jpg" fit="fill"></el-image>
      </div>
      <div class="box1" style="bacground: rgba(255, 255, 255, 0)">
        <div class="box1_left pointer">
          <div
            v-for="(item, index) in leftlist"
            :key="index"
            @click="changeleft(item.path,index)"
            class="box1_left_center"
            :style="cIndex == index ? 'color: #3973ff;' : ''"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="box1_right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      leftlist: [
        {
          name: "房租预警",
          path: 'warning'
        },
        {
          name: "其他预警",
          path: 'otherwarning'
        },
        {
          name: "企业列表",
          path: 'companylist'
        },
        {
          name: "申请列表",
          path: 'applylist'
        },
        // {
        //   name: "账号分配",
        //   path: 'account'
        // }
      ],
      cIndex: 0
    };
  },
  watch:{
    $route (to, from, next) {
        console.log('1111111',to)
      if(to.path == '/system'){
        // console.log('systeminfo',this.systeminfo)
        this.$router.push({name: this.leftlist[0].path})
        this.cIndex = 0
      }else{
        for(let i in this.leftlist){
            if(to.path == '/system/' + this.leftlist[i].path){
                this.cIndex = i;
            }
        }
      }

      console.log('beforeRouteEnter',to.path)
    }
  },
  methods: {
    tohome(){
      this.$router.push({path: '/'})
    },
    changeleft(path,index) {
      this.$router.push({name: path})
      this.cIndex = index;
    }
  },
  created() {
      this.$router.push({name: 'warning'});
  },
};
</script>
<style scoped>

.box_center {
  width: 66%;
  height: 58px;
}

.box1 {
  align-items: flex-start;
  width: 82%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-bottom: 50px;
  position: relative;
  top: -90px;
}
.box1_left {
  background-color: #ffffff;
  border-radius: 14px;
}
.box1_left_center {
  width: 140px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #1d1d1d;
  border-bottom: 1px solid #eeeeee;
}
.box1_right {
  width: 90%;
  border-radius: 14px;
  background-color: #ffffff;
  /* padding-bottom: 60px;	 */
}
.topnav{
    width: 100%;
	height: 80px;
	background-color: rgba(27,27,27,0.2);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
}
</style>



// WEBPACK FOOTER //
// system.vue?3c3b7c8a